// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9b-4";
export var collapsed = "_9b-1";
export var headerBar = "_9b-0";
export var leftHeaderContent = "_9b-3";
export var subjectContainer = "_9b-2";